module.exports = __webpack_public_path__ + "img/banne01_logo.7b2326f3.png";